'use client'

import React, { Fragment } from 'react'
import type { ComponentType } from 'react'

import { ContentBlock } from '@/blocks/Content/Component'
import { BannerBlock } from '@/blocks/Banner/Component'
import { MediaBlock as MediaBlockComponent } from '@/blocks/MediaBlock/Component'

import CalculatorBlock from '@/blocks/Calculator/Component'
import ContactUsBlock from '@/blocks/ContactUs/Component'
import ProjectHistory2Block from '@/blocks/ProjectHistory_2/Component'
import S1Hero1Block from '@/blocks/S1_Hero_1/Component'
import S1Hero2Block from '@/blocks/S1_Hero_2/Component'
import S1Hero4Block from '@/blocks/S1_Hero_4/Component'
import S1L23Block from '@/blocks/S1_L2_3/Component'
import S1L31Block from '@/blocks/S1_L3_1/Component'
import S1L32Block from '@/blocks/S1_L3_2/Component'
import S1L33Block from '@/blocks/S1_L3_3/Component'
import S1L35Block from '@/blocks/S1_L3_5/Component'
import S1Blog2Block from '@/blocks/S1_blog_2/Component'
import S2Hero2Block from '@/blocks/S2_Hero_2/Component'
import S2Hero3Block from '@/blocks/S2_Hero_3/Component'
import S2Hero5Block from '@/blocks/S2_Hero_5/Component'
import S2Hero6Block from '@/blocks/S2_Hero_6/Component'
import S2About4Block from '@/blocks/S2_about_4/Component'
import S3L21Block from '@/blocks/S3_L2_1/Component'
import S3L22Block from '@/blocks/S3_L2_2/Component'
import S3L23Block from '@/blocks/S3_L2_3/Component'
import S3L31Block from '@/blocks/S3_L3_1/Component'
import S3L33Block from '@/blocks/S3_L3_3/Component'
import S3About2Block from '@/blocks/S3_about_2/Component'
import S3About3Block from '@/blocks/S3_about_3/Component'
import S3About5Block from '@/blocks/S3_about_5/Component'
import S3About5LBlock from '@/blocks/S3_about_5L/Component'
import S3About6Block from '@/blocks/S3_about_6/Component'
import S3Blogopen2Block from '@/blocks/S3_blogopen_2/Component'
import S3Blogopen3Block from '@/blocks/S3_blogopen_3/Component'
import S3Team1Block from '@/blocks/S3_team_1/Component'
import S3Team2Block from '@/blocks/S3_team_2/Component'
import SearchBlock from '@/blocks/Search/Component'
import ServiceAreaBlock from '@/blocks/ServiceArea/Component'

type BlockComponent = ComponentType<any>

const blockComponents: Record<string, BlockComponent> = {
  content: ContentBlock,
  banner: BannerBlock,
  mediaBlock: MediaBlockComponent,
  calculator: CalculatorBlock,
  'contact-us': ContactUsBlock,
  'project-history-2': ProjectHistory2Block,
  's1-hero-1': S1Hero1Block,
  's1-hero-2': S1Hero2Block,
  's1-hero-4': S1Hero4Block,
  's1-l2-3': S1L23Block,
  's1-l3-1': S1L31Block,
  's1-l3-2': S1L32Block,
  's1-l3-3': S1L33Block,
  's1-l3-5': S1L35Block,
  's1-blog-2': S1Blog2Block,
  's2-hero-2': S2Hero2Block,
  's2-hero-3': S2Hero3Block,
  's2-hero-5': S2Hero5Block,
  's2-hero-6': S2Hero6Block,
  's2-about-4': S2About4Block,
  's3-l2-1': S3L21Block,
  's3-l2-2': S3L22Block,
  's3-l2-3': S3L23Block,
  's3-l3-1': S3L31Block,
  's3-l3-3': S3L33Block,
  's3-about-2': S3About2Block,
  's3-about-3': S3About3Block,
  's3-about-5': S3About5Block,
  's3-about-5l': S3About5LBlock,
  's3-about-6': S3About6Block,
  's3-blogopen-2': S3Blogopen2Block,
  's3-blogopen-3': S3Blogopen3Block,
  's3-team-1': S3Team1Block,
  's3-team-2': S3Team2Block,
  search: SearchBlock,
  'service-area': ServiceAreaBlock,
}

type RenderBlocksProps = {
  blocks?: Array<Record<string, unknown> & { blockType?: string }>
  doc?: Record<string, unknown> | null
  globalProps?: Record<string, unknown>
}

const RenderBlocks: React.FC<RenderBlocksProps> = ({ blocks = [], doc, globalProps = {} }) => {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return null
  }

  return (
    <Fragment>
      {blocks.map((block, index) => {
        const blockType = typeof block.blockType === 'string' ? block.blockType : undefined
        const Block = (blockType && blockComponents[blockType]) ?? blockComponents.content

        if (!Block) {
          return null
        }

        const key = (typeof block.id === 'string' && block.id.length > 0) ? block.id : `block-${index}`

        return (
          <div key={key} id={block.blockName as string || ''}>
            <Block {...block} doc={doc} {...globalProps} />
          </div>
        )
      })}
    </Fragment>
  )
}

export default RenderBlocks
